import type { ColumnDefinition } from './table-components/table-body/table-body-components/table-row/table-row-components/table-cell/table-cell-types/column-definition';
import type { GetRowKey } from './table-components/table-body/table-body-components/table-row/table-row-types/get-row-key';
import type { RowClassname } from './table-components/table-body/table-body-components/table-row/table-row-types/row-classname';
import TableBody from './table-components/table-body/TableBody';
import TableHead from './table-components/table-head/TableHead';

export type TableProps<Row> = {
  rows: Row[];
  columns: ColumnDefinition<Row>[];
  rowClassName?: RowClassname<Row>;
  headerClassName?: string;
  cellClassName?: string;
  tableClassName?: string;
  onRowClick?: (row: Row) => void;
  sortBy?: keyof Row | ((row: Row) => number | string);
  sortDirection?: 'asc' | 'desc';
  headless?: boolean;
  getRowKey?: GetRowKey<Row>;
};
  
export default function Table<Row>({ rows, columns, headerClassName, rowClassName, tableClassName, cellClassName, headless, sortBy, sortDirection, getRowKey, onRowClick }: TableProps<Row>) {
  return (
    <table className={tableClassName}>
      {!headless && <TableHead {...{ columns, headerClassName }} />}
      <TableBody {...{ rows, columns, rowClassName, cellClassName, sortBy, sortDirection, getRowKey, onRowClick }} />
    </table>
  );
}